<template>
  <div class="layout">
    <div class="tool">
      <Button type="primary" ghost shape="circle" @click="Refresh">刷新</Button>
    </div>
    <!-- 根据直播间的 watchStatus 判断 结束显示数据 -->
    <div v-if="info">
      <div class="infobox">
        <div class="info-item">
          <p>直播时长</p>
          <span>{{ playDuration | time_sort2 }}</span>
        </div>
        <div class="info-item">
          <p>观看人次</p>
          <span>{{plays}}</span>
        </div>
        <div class="info-item">
          <p>观看人数</p>
          <span>{{viewers}}</span>
        </div>
      </div>
      <div class="info-table" v-if="false">
        <div class="it-title">
          <Row :gutter="20" type="flex" align="middle">
            <Col span="12" class="it-title_p">直播时长统计</Col>
            <Col span="12" class="it-title_p"><Button type="primary" @click="exportHandle(url)">导出</Button></Col>
          </Row>
        </div>
        <div class="it-content">
          <Table :columns="liveTimeColumns" :data="liveTimeArr" :disabled-hover="false" no-data-text="暂无数据">
          </Table>
        </div>
      </div>

      <div class="info-table">
        <div class="it-title">
          <Row :gutter="20" type="flex" align="middle">
            <Col span="12" class="it-title_p">企业店铺统计</Col>
            <Col span="12" class="it-title_p"><Button type="primary" @click="ExcelExportCompanyHandle">导出</Button></Col>
          </Row>
        </div>
        <div class="it-content">
          <Table :columns="companyColumns" :data="companyArr" :disabled-hover="false" no-data-text="暂无数据">
            <template slot-scope="{ row, index }" slot="id">{{ index + 1 }}</template>
            <template slot-scope="{ row, index }" slot="phone">
              <span v-if="row.liveView">{{ row.liveView.phoneNumber }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="name">
              <span v-if="row.liveView">{{ row.liveView.name }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="sex">
              <span v-if="row.liveView && row.liveView.gender === 'male'">男</span>
              <span v-if="row.liveView && row.liveView.gender === 'female'">女</span>
              <span v-if="row.liveView && row.liveView.gender === 'unknown'">其他</span>
            </template>
            <template slot-scope="{ row, index }" slot="companyName">
              <span v-if="row.liveView">{{ row.liveView.companyName }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="country">
              <span v-if="row.liveView">{{ row.liveView.country }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="area">
              <span v-if="row.liveView">{{ row.liveView.province }} </span>
              <span v-if="row.liveView">-{{ row.liveView.city }} </span>
              <span v-if="row.liveView">-{{ row.liveView.county }} </span>
            </template>
            <template slot-scope="{ row, index }" slot="department">
              <span v-if="row.liveView">{{ row.liveView.department }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="title">
              <span v-if="row.liveView">{{ row.liveView.jobTitle }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="viewCompany">
              <span>{{ row.companyName }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="viewProduct">
              <span v-if="row.product
              ">{{ row.product.name }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="inTime">
              <span v-if="row.inTime
              ">{{ row.inTime | moment('YYYY-MM-DD HH:mm:ss') }}</span>
            </template>
          </Table>
          <div class="my-page" v-if="totalCount > size" style="margin: 20px;text-align: center;">
            <Page show-total show-elevator :page-size="size" :current="page" :total="totalCount" @on-change="changePage" @on-page-size-change="changePageSize" />
          </div>
        </div>
      </div>
      <div class="info-table">
        <div class="it-title">
          <Row :gutter="20" type="flex" align="middle">
            <Col span="12" class="it-title_p">直播产品统计</Col>
            <Col span="12" class="it-title_p"><Button type="primary" @click="ExcelExportProductHandle">导出</Button></Col>
          </Row>
        </div>
        <div class="it-content">
          <Table :columns="productColumns" :data="productArr" :disabled-hover="false" no-data-text="暂无数据">
            <template slot-scope="{ row, index }" slot="id">{{ index + 1 }}</template>
            <template slot-scope="{ row, index }" slot="phone">
              <span v-if="row.liveView">{{ row.liveView.phoneNumber }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="name">
              <span v-if="row.liveView">{{ row.liveView.name }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="sex">
              <span v-if="row.liveView && row.liveView.gender === 'male'">男</span>
              <span v-if="row.liveView && row.liveView.gender === 'female'">女</span>
              <span v-if="row.liveView && row.liveView.gender === 'unknown'">其他</span>
            </template>
            <template slot-scope="{ row, index }" slot="companyName">
              <span v-if="row.liveView">{{ row.liveView.companyName }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="country">
              <span v-if="row.liveView">{{ row.liveView.country }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="area">
              <span v-if="row.liveView">{{ row.liveView.province }} </span>
              <span v-if="row.liveView">-{{ row.liveView.city }} </span>
              <span v-if="row.liveView">-{{ row.liveView.county }} </span>
            </template>
            <template slot-scope="{ row, index }" slot="department">
              <span v-if="row.liveView">{{ row.liveView.department }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="title">
              <span v-if="row.liveView">{{ row.liveView.jobTitle }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="viewCompany">
              <span>{{ row.companyName }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="viewProduct">
              <span v-if="row.product
              ">{{ row.product.name }}</span>
            </template><template slot-scope="{ row, index }" slot="inTime">
              <span v-if="row.inTime
              ">{{ row.inTime | moment('YYYY-MM-DD HH:mm:ss') }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="shareCount">
              <span>{{ row.shareCount }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="collectCount">
              <span>{{ row.collectCount }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="releaseContent">
              <span>{{ row.releaseContent }}</span>
            </template>
          </Table>
          <div class="my-page" v-if="newTotalCount > newSize" style="margin: 20px;text-align: center;">
            <Page show-total show-elevator :page-size="newSize" :current="newPage" :total="newTotalCount" @on-change="newchangePage" @on-page-size-change="newchangePageSize" />
          </div>
        </div>
      </div>


      <div class="info-table">
        <div class="it-title">
          <Row :gutter="20" type="flex" align="middle">
            <Col span="12" class="it-title_p">用户信息统计</Col>
            <Col span="12" class="it-title_p"><Button type="primary" @click="ExcelExportUserHandle">导出</Button></Col>
          </Row>
        </div>
        <div class="it-content">
          <Table :columns="userColumns" :data="userArr" :disabled-hover="false" no-data-text="暂无数据">
            <template slot-scope="{ row, index }" slot="id">{{ index + 1 }}</template>
            <template slot-scope="{ row, index }" slot="phone">
              <span v-if="row.liveView">{{ row.liveView.phoneNumber }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="name">
              <span v-if="row.liveView">{{ row.liveView.name }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="sex">
              <span v-if="row.liveView && row.liveView.gender === 'male'">男</span>
              <span v-if="row.liveView && row.liveView.gender === 'female'">女</span>
              <span v-if="row.liveView && row.liveView.gender === 'unknown'">其他</span>
            </template>
            <template slot-scope="{ row, index }" slot="companyName">
              <span v-if="row.liveView">{{ row.liveView.companyName }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="country">
              <span v-if="row.liveView">{{ row.liveView.country }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="area">
              <span v-if="row.liveView">{{ row.liveView.province }} </span>
              <span v-if="row.liveView">-{{ row.liveView.city }} </span>
              <span v-if="row.liveView">-{{ row.liveView.county }} </span>
            </template>
            <template slot-scope="{ row, index }" slot="department">
              <span v-if="row.liveView">{{ row.liveView.department }}</span>
            </template>
            <template slot-scope="{ row, index }" slot="title">
              <span v-if="row.liveView">{{ row.liveView.jobTitle }}</span>
            </template>
     
           <template slot-scope="{ row, index }" slot="inTime">
              <span v-if="row.inTime
              ">{{ row.inTime | moment('YYYY-MM-DD HH:mm:ss') }}</span>
            </template>

          </Table>
          <div class="my-page" v-if="userTotalCount > userSize" style="margin: 20px;text-align: center;">
            <Page show-total show-elevator :page-size="userSize" :current="userPage" :total="userTotalCount" @on-change="userchangePage" @on-page-size-change="userchangePageSize" />
          </div>
        </div>
      </div>


    </div>
    <div class="empty" v-else>
      您的直播还未结束，如已结束请点击刷新按钮查看统计结果
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "host-activity-live-data",
  components: {},
  props: {},
  data () {
    return {
      info: null,
      showData: true,
      page: 1,
      size: 5,
      totalCount: 0,
      newPage: 1,
      newSize: 5,
      newTotalCount: 0,
      userPage: 1,
      userSize: 5,
      userTotalCount: 0,
      // 直播时长统计
      liveTimeColumns: [
        {
          title: "直播id",
          // slot: "id",
          key: "id",
          align: "center",
          width: "80",
        },
        {
          title: "用户手机号",
          // slot: "phone",
          key: "phone",
          align: "center",
        },
        {
          title: "姓名",
          // slot: "name",
          key: "name",
          align: "center",
        },
        {
          title: "性别",
          // slot: "sex",
          key: "sex",
          align: "center",
        },
        {
          title: "单位名称",
          // slot: "companyName",
          key: "companyName",
          align: "center",
        },
        {
          title: "国家",
          // slot: "country",
          key: "country",
          align: "center",
        },
        {
          title: "所属地区",
          // slot: "area",
          key: "area",
          align: "center",
        },
        {
          title: "部门",
          // slot: "department",
          key: "department",
          align: "center",
        },
        {
          title: "职称",
          // slot: "title",
          key: "title",
          align: "center",
        },
        {
          title: "浏览器类型",
          // slot: "type",
          key: "type",
          align: "center",
        },
        {
          title: "分享直播间次数",
          // slot: "share",
          key: "share",
          align: "center",
        },
        {
          title: "点赞次数",
          // slot: "like",
          key: "like",
          align: "center",
        },
      ],
      // 企业店铺统计
      companyColumns: [
        {
          title: "直播id",
          slot: "id",
          key: "id",
          align: "center",
          width: "80",
        },
        {
          title: "用户手机号",
          slot: "phone",
          key: "phone",
          align: "center",
        },
        {
          title: "姓名",
          slot: "name",
          key: "name",
          align: "center",
        },
        {
          title: "性别",
          slot: "sex",
          key: "sex",
          align: "center",
        },
        {
          title: "单位名称",
          slot: "companyName",
          key: "companyName",
          align: "center",
        },
        {
          title: "国家",
          slot: "country",
          key: "country",
          align: "center",
        },
        {
          title: "所属地区",
          slot: "area",
          key: "area",
          align: "center",
        },
        {
          title: "部门",
          slot: "department",
          key: "department",
          align: "center",
        },
        {
          title: "职称",
          slot: "title",
          key: "title",
          align: "center",
        },
        {
          title: "浏览企业店铺名称",
          slot: "viewCompany",
          key: "viewCompany",
          align: "center",
        },
        {
          title: "浏览产品名称",
          slot: "viewProduct",
          key: "viewProduct",
          align: "center",
        },
        {
          title: "访问时间",
          slot: "inTime",
          key: "inTime",
          align: "center",
        },
      ],
      // 直播产品统计
      productColumns: [
        {
          title: "直播id",
          slot: "id",
          key: "id",
          align: "center",
          width: "80",
        },
        {
          title: "用户手机号",
          slot: "phone",
          key: "phone",
          align: "center",
        },
        {
          title: "姓名",
          slot: "name",
          key: "name",
          align: "center",
        },
        {
          title: "性别",
          slot: "sex",
          key: "sex",
          align: "center",
        },
        {
          title: "单位名称",
          slot: "companyName",
          key: "companyName",
          align: "center",
        },
        {
          title: "国家",
          slot: "country",
          key: "country",
          align: "center",
        },
        {
          title: "所属地区",
          slot: "area",
          key: "area",
          align: "center",
        },
        {
          title: "部门",
          slot: "department",
          key: "department",
          align: "center",
        },
        {
          title: "职称",
          slot: "title",
          key: "title",
          align: "center",
        },
        {
          title: "浏览企业店铺名称",
          slot: "viewCompany",
          key: "viewCompany",
          align: "center",
        },
        {
          title: "浏览产品名称",
          slot: "viewProduct",
          key: "viewProduct",
          align: "center",
        },
        // {
        //   title: "浏览产品展区",
        //   slot: "viewProduct",
        //   key: "viewProduct",
        //   align: "center",
        // },
        {
          title: "访问时间",
          slot: "inTime",
          key: "inTime",
          align: "center",
        },
        {
          title: "分享数量",
          slot: "shareCount",
          key: "shareCount",
          align: "center",
        },
        {
          title: "收藏数量",
          slot: "collectCount",
          key: "collectCount",
          align: "center",
        },
        {
          title: "洽谈内容",
          slot: "releaseContent",
          key: "releaseContent",
          align: "center",
        },
      ],
      // 用户信息统计
      userColumns: [
        {
          title: "直播id",
          slot: "id",
          key: "id",
          align: "center",
          width: "80",
        },
        {
          title: "用户手机号",
          slot: "phone",
          key: "phone",
          align: "center",
        },
        {
          title: "姓名",
          slot: "name",
          key: "name",
          align: "center",
        },
        {
          title: "性别",
          slot: "sex",
          key: "sex",
          align: "center",
        },
        {
          title: "单位名称",
          slot: "companyName",
          key: "companyName",
          align: "center",
        },
        {
          title: "国家",
          slot: "country",
          key: "country",
          align: "center",
        },
        {
          title: "所属地区",
          slot: "area",
          key: "area",
          align: "center",
        },
        {
          title: "部门",
          slot: "department",
          key: "department",
          align: "center",
        },
        {
          title: "职称",
          slot: "title",
          key: "title",
          align: "center",
        },
        // {
        //   title: "浏览企业店铺名称",
        //   slot: "viewCompany",
        //   key: "viewCompany",
        //   align: "center",
        // },
        // {
        //   title: "浏览产品名称",
        //   slot: "viewProduct",
        //   key: "viewProduct",
        //   align: "center",
        // },
        // {
        //   title: "浏览产品展区",
        //   slot: "viewProduct",
        //   key: "viewProduct",
        //   align: "center",
        // },
        {
          title: "访问时间",
          slot: "inTime",
          key: "inTime",
          align: "center",
        },
        // {
        //   title: "分享数量",
        //   slot: "shareCount",
        //   key: "shareCount",
        //   align: "center",
        // },
        // {
        //   title: "收藏数量",
        //   slot: "collectCount",
        //   key: "collectCount",
        //   align: "center",
        // },
        // {
        //   title: "洽谈内容",
        //   slot: "releaseContent",
        //   key: "releaseContent",
        //   align: "center",
        // },
      ],
      liveTimeArr: [
        {
          id: '2',
          phone: '18596325663',
          name: '李四',
          sex: '男',
          companyName: '慕渊（上海）智能科技有限公司',
          country: '中国',
          area: '上海市-上海市中国',
          department: '技术部',
          title: '业务经理',
          type: '类型1',
          share: '1',
          like: '1',
        },
      ],
      companyArr: [],
      productArr: [],
      userArr: [],
    };
  },
  watch: {},
  computed: {
    activityId () {
      return this.$route.query.activityId;
    },
    ...mapGetters({
      channel: "liveModule/getChannel",
    }),
    // 直播时长
    playDuration () {
      let playDuration = '';
      if (this.info) {
        playDuration = this.info.liveMobilePlayDuration + this.info.livePcPlayDuration;
      }
      return playDuration || '';
    },
    // 观看人次
    plays () {
      let plays = '';
      if (this.info) {
        plays = this.info.mobileVideoView + this.info.pcVideoView;
      }
      return plays ? plays + '次' : '';
    },
    // 观看人次
    viewers () {
      let viewers = '';
      if (this.info) {
        viewers = this.info.mobileUniqueViewer + this.info.pcUniqueViewer;
      }
      return viewers ? viewers + '人' : '';
    },
  },
  methods: {
    ...mapActions({
      ExcelExportProduct: 'liveModule/ExcelExportProduct',
      ExcelExportCompany: 'liveModule/ExcelExportCompany',
      ExcelExportUser: 'liveModule/ExcelExportUser',
      LiveViewProductLogPageQueryInput: 'liveModule/LiveViewProductLogPageQueryInput',
      LiveViewUserLogPageQueryInput: 'liveModule/LiveViewUserLogPageQueryInput',
      getliveinfobyid: 'liveModule/getliveinfobyid',
      refreshSummary: 'liveModule/refreshSummary',
      channelSettingUpdateSplash: 'liveModule/channelSettingUpdateSplash',
    }),
    exportHandle (url) {
      window.open(url, '_blank');
    },
    async init () {
      let res = await this.getliveinfobyid(this.activityId);
      console.log('getliveinfobyid', res);
      this.info = res || null;

      this.loadUser();
      this.loadPro();
      this.loadCompany();
    },
    async loadUser () {
      let opt = {
        page: this.userPage,
        size: this.userSize,
        activityId: this.activityId,
      }
      let resPro = await this.LiveViewUserLogPageQueryInput(opt);
      console.log('resPro', resPro);
      if (resPro && resPro.items) {
        this.userArr = resPro.items;
        console.log('productArr', this.productArr);
        this.userTotalCount = resPro.totalCount;
      }
    },
    async loadPro () {
      let opt = {
        page: this.newPage,
        size: this.newSize,
        activityId: this.activityId,
      }
      let resPro = await this.LiveViewProductLogPageQueryInput(opt);
      console.log('resPro', resPro);
      if (resPro && resPro.items) {
        this.productArr = resPro.items;
        console.log('productArr', this.productArr);
        this.newTotalCount = resPro.totalCount;
      }
    },
    async loadCompany () {
      let opt = {
        page: this.page,
        size: this.size,
        activityId: this.activityId,
      }
      let resComp = await this.LiveViewCompanyLogPageQueryInput(opt);
      console.log('resComp', resComp);
      if (resComp && resComp.items) {
        this.companyArr = resComp.items;
        console.log('companyArr', this.companyArr);
        this.totalCount = resComp.totalCount;
      }
    },
    changePage (e) {
      this.page = e;
      this.loadCompany();
    },
    changePageSize (e) {
      this.size = e;
      this.loadCompany();
    },
    newchangePage (e) {
      this.newPage = e;
      this.loadPro();
    },
    newchangePageSize (e) {
      this.newSize = e;
      this.loadPro();
    },
    userchangePage (e) {
      this.userPage = e;
      this.loadUser();
    },
    userchangePageSize (e) {
      this.userSize = e;
      this.loadUser();
    },
    async Refresh () {
      let res = await this.refreshSummary(this.activityId);
      if (res) {
        this.$Message.success('刷新成功！')
        setTimeout(() => {
          this.init();
        });
        return;
      } else {
        this.$Message.error('刷新失败！')
      }
    },
    async ExcelExportUserHandle () {
      let arr = await this.ExcelExportUser(this.activityId);
      console.log('arr', arr);
      if (arr) {
        const aLink = document.createElement("a");
        let blob = new Blob([arr], {
          type: "application/vnd.ms-excel"
        });
        aLink.href = URL.createObjectURL(blob);
        aLink.setAttribute("download", "用户信息统计" + ".xlsx"); // 设置下载文件名称
        document.body.appendChild(aLink);
        aLink.click();
      }
    },
    async ExcelExportCompanyHandle () {
      let arr = await this.ExcelExportProduct(this.activityId);
      console.log('arr', arr);
      if (arr) {
        const aLink = document.createElement("a");
        let blob = new Blob([arr], {
          type: "application/vnd.ms-excel"
        });
        aLink.href = URL.createObjectURL(blob);
        aLink.setAttribute("download", "企业店铺统计" + ".xlsx"); // 设置下载文件名称
        document.body.appendChild(aLink);
        aLink.click();
      }
    },
    async ExcelExportProductHandle () {
      let arr = await this.ExcelExportProduct(this.activityId);
      if (arr) {
        const aLink = document.createElement("a");
        let blob = new Blob([arr], {
          type: "application/vnd.ms-excel"
        });
        aLink.href = URL.createObjectURL(blob);
        aLink.setAttribute("download", "直播产品统计" + ".xlsx"); // 设置下载文件名称
        document.body.appendChild(aLink);
        aLink.click();
      }
    },

  },
  created () { },
  mounted () {
    this.init();
  }
}

</script>

<style lang="scss" scoped>
.layout {
  margin: 20px;
  min-height: 500px;
  background: #fff;
}

.empty {
  font-size: 18px;
  font-weight: bold;
  height: 400px;
  background-color: #ffff;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  margin: 20px;
}

.info-table {
  .it-title {
    background: rgba(247, 247, 247, 1);
    font-weight: bold;
    font-size: 20px;
    height: 50px;
    padding: 0 20px;

    &_p {
      height: 50px;
      display: flex;
      align-items: center;
      flex: 1;

      &:last-child {
        flex-direction: row-reverse;
      }
    }
  }

  .it-content {
    padding: 20px;
  }
}

.tool {
  padding: 20px;
  text-align: right;
}

.infobox {
  display: flex;
  padding: 0 40px 40px;

  .info-item {
    flex: 1;
    line-height: 40px;
    font-size: 22px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    text-align: center;

    p {
      width: 100%;
    }

    span {
      font-size: 30px;
      width: 100%;
    }
  }
}
</style>
